// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-textformat-italic"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10 3H12.5M10 3H7.5M10 3V21M10 21H7.5M10 21H12.5M6 7.5H3V16.5H6M21 12.5V16.5H14","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M18.25 5.75L18.7697 6.98028L20 7.5L18.7697 8.01972L18.25 9.25L17.7303 8.01972L16.5 7.5L17.7303 6.98028L18.25 5.75Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-textformat-italic')
export default class AiTextformatItalicIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-textformat-italic',
    }
  }
}
